import './index.scss'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {ClockIcon, HelpIcon} from '../../../icons'
import Tooltip from '../tooltip'
import {colors} from '../../../utils/colors'
import 'rc-time-picker/assets/index.css'
import TimePicker from 'rc-time-picker'
import {useRef} from 'react'
import Error from '../error'
import moment from 'moment'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const CustomTimePicker = ({
    placeholder,
    error,
    infoText,
    value,
    onChange,
    isFocused,
    isDisabled
}) => {
    const timePickerRef = useRef()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const handleChange = (value) => {
        onChange(value?.format('HH:mm:ss') || '')
    }

    return (
        <div className="timepicker-container"
            ref={timePickerRef}>
            <div className={classNames('time-picker-box', {
                'active': value && isFocused,
                dark: isDarkMode
            })}>
                <TimePicker
                    showSecond={false}
                    onChange={(value) => handleChange(value)}
                    inputIcon={!value && <span className='icon'><span>{placeholder}</span><ClockIcon/></span>}
                    inputReadOnly
                    value={value ? moment(value, 'HH:mm:ss') : null}
                    disabled={isDisabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    className={error ? 'error' : ''}

                />
                <div className="tooltip-container">
                    <Tooltip placement="left" trigger="click" content={infoText} appendTo={timePickerRef?.current}>
                        <HelpIcon stroke={colors.colorBgFilter} width="24" height="24" />
                    </Tooltip>
                </div>
            </div>
            {error && <Error error={error} hasIcon/>}
        </div>
    )
}

export default CustomTimePicker
